// TODO: DON'T FORGET TO UPDATE I18N packages/roles/src/i18n/rolesi18n.ts

/**
pnpm jest packages/service-console/src/modules/company/__tests__/CompanyConsoleQueries.spec.ts \
packages/service-console/src/modules/permissions/role/__tests__/RoleList.spec.ts \
packages/service-console/src/modules/company/mutations/console/__tests__/CompanyAddMutation.spec.ts \
packages/service-console/src/modules/company/mutations/console/__tests__/CompanyAddMutationWallet.spec.ts \
packages/service-console/src/modules/company/mutations/console/__tests__/CompanyAddWooviMutation.spec.ts -u

**/

export const ROLES = {
  ADMIN: {
    ALL: {
      ALL: 'ADMIN',
    },
  },
  ADJUST: {
    ALL: 'ADJUST::ALL',
  },
  API: {
    ALL: 'API::ALL',
    ADMIN: { ALL: 'API::ADMIN::ALL' },
  },
  CORE: {
    ALL: 'CORE::ALL',
    APPLICATION: 'CORE::APPLICATION',
    LOGIN: 'CORE::LOGIN',
    PREFERENCES: {
      CHANGE_EMAIL: 'CORE::PREFERENCES::CHANGE_EMAIL',
      CHANGE_JOB_TITLE: 'CORE::PREFERENCES::CHANGE_JOB_TITLE',
      CHANGE_MANAGER: 'CORE::PREFERENCES::CHANGE_MANAGER',
      CHANGE_NAME: 'CORE::PREFERENCES::CHANGE_NAME',
      CHANGE_NICKNAME: 'CORE::PREFERENCES::CHANGE_NICKNAME',
      CHANGE_PASSWORD: 'CORE::PREFERENCES::CHANGE_PASSWORD',
      CHANGE_TAXID: 'CORE::PREFERENCES::CHANGE_TAXID',
    },
    USER: {
      INVITE: 'CORE::USER::INVITE',
      MANAGE_TEAM: 'CORE::USER::MANAGE_TEAM',
    },
  },
  DISPUTE: {
    ALL: 'DISPUTE::ALL',
    VIEW: 'DISPUTE::VIEW',
  },
  FRAUD: {
    ALL: 'FRAUD::ALL',
    EXPORT: 'FRAUD::EXPORT',
    VIEW: 'FRAUD::VIEW',
  },
  OPEN_PIX: {
    ACCOUNT_CREATE: 'OPEN_PIX::ACCOUNT_CREATE',
    ACCOUNT_BALANCE: 'OPEN_PIX::ACCOUNT_BALANCE',
    ACCOUNT_BALANCE_VIEW: 'OPEN_PIX::ACCOUNT_BALANCE_VIEW',
    ACCOUNT_STATEMENT: 'OPEN_PIX::ACCOUNT_STATEMENT',
    ACCOUNT_WITHDRAW: 'OPEN_PIX::ACCOUNT_WITHDRAW',
    ADMIN: { ALL: 'OPEN_PIX::ADMIN::ALL' },
    ALL: 'OPEN_PIX::ALL',
    API_WEBHOOK: 'OPEN_PIX::API_WEBHOOK',
    CHARGE_CREATE: 'OPEN_PIX::CHARGE_CREATE',
    CHARGE_DELETE: 'OPEN_PIX::CHARGE_DELETE',
    CHARGE_EXPORT: 'OPEN_PIX::CHARGE_EXPORT',
    CHARGE_REPORT: 'OPEN_PIX::CHARGE_REPORT',
    CHARGE_SEE_ALL: 'OPEN_PIX::CHARGE_SEE_ALL',
    CHARGE_SEE_MINE: 'OPEN_PIX::CHARGE_SEE_MINE',
    CHARGE_VIEW: 'OPEN_PIX::CHARGE_VIEW',
    CHARGES: 'OPEN_PIX::CHARGES',
    CUSTOMER_EXPORT: 'OPEN_PIX::CUSTOMER_EXPORT',
    CUSTOMERS: 'OPEN_PIX::CUSTOMERS',
    DISPUTE_ALL: 'OPEN_PIX::DISPUTE_ALL',
    DISPUTE_VIEW: 'OPEN_PIX::DISPUTE_VIEW',
    PAYMENTS: 'OPEN_PIX::PAYMENTS',
    QRCODES: 'OPEN_PIX::QRCODES',
    REFUND: 'OPEN_PIX::REFUND',
    REPORT: 'OPEN_PIX::REPORT',
    SELLER: 'OPEN_PIX::SELLER',
    TRANSACTIONS: 'OPEN_PIX::TRANSACTIONS',
    TRANSACTIONS_LIST: 'OPEN_PIX::TRANSACTIONS_LIST',
    TRANSACTIONS_EXPORT: 'OPEN_PIX::TRANSACTIONS_EXPORT',
    USER: { ALL: 'OPEN_PIX::USER::ALL' },
    INVOICE_ISSUE: 'OPENPIX::INVOICE_ISSUE',
    INVOICE_CANCEL: 'OPENPIX::INVOICE_CANCEL',
    INVOICE: {
      ISSUE: 'OPENPIX::INVOICE_ISSUE',
      CANCEL: 'OPENPIX::INVOICE_CANCEL',
      REPROCESS: 'OPENPIX::INVOICE_REPROCESS',
    },
    SUBACCOUNT: {
      ADMIN: 'OPEN_PIX::SUBACCOUNT::ADMIN',
      CREATE: 'OPEN_PIX::SUBACCOUNT::CREATE',
      DELETE: 'OPEN_PIX::SUBACCOUNT::DELETE',
      EDIT: 'OPEN_PIX::SUBACCOUNT::EDIT',
      VIEW: 'OPEN_PIX::SUBACCOUNT::VIEW',
      WITHDRAW: 'OPEN_PIX::SUBACCOUNT::WITHDRAW',
    },
    AFFILIATE: {
      CREATE: 'OPEN_PIX::AFFILIATE::CREATE',
    },
    REFUNDS: {
      REQUEST: 'OPEN_PIX::REFUNDS::REQUEST',
    },
  },
  OPENPIX_ADVANCED: {
    ADMIN: { ALL: 'OPENPIX_ADVANCED::ADMIN::ALL' },
    ALL: 'OPENPIX_ADVANCED::ALL',
  },
  PARTNER: {
    ALL: 'PARTNER::ALL',
  },
  PERMISSIONS: {
    ALL: 'PERMISSIONS::ALL',
  },
  PIX_OUT: {
    BILL: {
      APPROVE: 'PIX_OUT::BILL::APPROVE',
      REQUEST: 'PIX_OUT::BILL::REQUEST',
      VIEW: 'PIX_OUT::BILL::VIEW',
      DELETE: 'PIX_OUT::BILL::DELETE',
    },
  },
  PLANNING: {
    ALL: 'PLANNING::ALL',
    COST_REVENUE_CENTER: { ALL: 'PLANNING::COST_REVENUE_CENTER::ALL' },
  },
  SUPPORT: {
    ALL: 'SUPPORT::ALL',
  },
};
export const ADMIN_USER_ADMIN = ROLES.ADMIN.ALL.ALL;
export const ADMIN_USER_DEFAULT_ROLES = [ROLES.ADMIN.ALL.ALL];
export const ADMIN_ROLE = ROLES.ADMIN.ALL.ALL;

export const COMPANY_PROJECT_TYPES_ENUM = {
  OPEN_PIX: 'OPEN_PIX',
  WOOVI: 'WOOVI',
} as const;
